import { z } from 'zod';
export const publicWaitlistRequestSchema = z
    .object({
    email: z.string().trim().toLowerCase().email(),
    company: z.string().max(200).optional(),
})
    .strict();
export const publicWaitlistResponseSchema = z.object({
    ok: z.literal(true),
});
//# sourceMappingURL=waitlist.js.map